import { getParamsUrl } from '@/helpers/request'
import { preparePhone } from '@/helpers/functions'
import Repository from './Repository'

const action = 'documents'
const isProd = process.env.NODE_ENV === 'production'
const baseURL = isProd
  ? process.env.VUE_APP_API_URL_PROD
  : process.env.VUE_APP_API_URL
const hardwareToken = process.env.VUE_APP_HARDWARE_TOKEN

export default {
  getUpdatedRegistry(day_id, by_mail, registry = 'registry') {
    const token = localStorage.getItem('auth-token')
    const params = getParamsUrl({
      day_id,
      by_mail,
      'bearer-token': token,
    })

    return Repository.get(`/excel-builder/${registry}${params}`)
  },
  getReport(data, action = '/excel-builder/transport-report') {
    return Repository.post(action, data, { responseType: 'arraybuffer' })
  },
  sendToEmail(emails, data) {
    const params = '?by_mail=' + emails

    return Repository.post('excel-builder/template/registry' + params, data)
  },
  getTTN(ttn_id) {
    return Repository.post(
      'excel-builder/template/ttn',
      { ttn_id },
      { responseType: 'arraybuffer' },
    )
  },
  getDocument(sourceType = '', source_id, typeCode = '') {
    let params = {
      rel_name: sourceType,
      expand: 'files',
    }

    if (source_id) {
      params['rel_id'] = source_id
    }
    if (typeCode) {
      params['type_code'] = typeCode
    }

    return Repository.get(action, { params })
  },
  createDocument(sourceType, source_id, typeId, fields = {}) {
    const params = {
      ...fields,
      document_type_id: typeId,
      links: {},
    }

    params.links[sourceType] = [source_id]

    return Repository.post(action, params)
  },
  deleteDocument(data) {
    return Repository.delete(action + '/' + data.id)
  },
  reportSubmit(data) {
    return Repository.put('total-report', data)
  },
  getReportLink(action, settings = {}, flag = true) {
    const token = localStorage.getItem('auth-token')
    let params = `?bearer-token=${token}`

    for (let key in settings) {
      if (key === 'phone') {
        settings[key] = preparePhone(settings[key])
      }
      params += `&${key}=${settings[key]}`
    }
    const url = flag ? baseURL : ''

    return url + action + params
  },
  setReportFiles(action, data) {
    return Repository.post(action, data)
  },
  getNomenclature(nomenclature = null) {
    if (!nomenclature) {
      return null
    }

    let str = ''
    let arr = Object.entries(nomenclature)

    arr.forEach(([key, value]) => (str += `&${key}=${value}`))

    return str
  },
  createReport(name = 'Example', objIds, unique = 1) {
    const action = `total-report`

    return Repository.post(action, {
      name,
      ...objIds,
      unique,
    })
  },
  createReportForDocuments(name = 'Example', organiztionInn, date) {
    const action = `total-report`

    return Repository.post(action, {
      name,
      org_inn: Number(organiztionInn),
      date_from: date.from,
      date_to: date.to,
      by_rang: 1,
      unique: 0,
    })
  },
  generateReport(
    id,
    scopeData,
    watermarkData,
    combineData,
    nomenclature = null,
    blackWhite,
  ) {
    const action = `total-report/${id}/retry`
    let scope = ''
    let watermark = ''
    let black_white = ''
    let combine = ''
    let paramsNomenclature = this.getNomenclature(nomenclature)

    if (scopeData) {
      if (scopeData === 1) {
        scope = '?scope=1'
      } else {
        scope = `?scope=${scopeData.join(',')}`
      }
    }
    if (scope) {
      black_white = blackWhite ? `&black_white=${blackWhite.join(',')}` : ''
      watermark = watermarkData ? `&watermark=${watermarkData.join(',')}` : ''
      combine = combineData ? `&combine=${combineData.join(',')}` : ''
    }

    return Repository.get(
      action + scope + watermark + combine + paramsNomenclature + black_white,
    )
  },
  getReportFiles(action, id) {
    return Repository.get(`${baseURL}${action}/${id}`)
  },
  getActReport(reqParams = {}, val) {
    const token = localStorage.getItem('auth-token')
    const params = getParamsUrl({
      ...reqParams,
      'bearer-token': token,
    })

    return `${baseURL}excel-builder/template/${val}${params}`
  },
  getTypes() {
    return Repository.get('document-types')
  },
  update(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  rename(data) {
    return Repository.put(`${action}/${data.document_id}`, {
      number: data.number,
    })
  },

  getZip(id, isHardware = true) {
    const token = isHardware
      ? hardwareToken
      : localStorage.getItem('auth-token')

    return Repository.get(`/documents/zip/${id}?token=${token}`)
  },

  getZipUrl(id) {
    return `${baseURL}documents/zip-link?token=${hardwareToken}&document_id=${id}`
  },
  getZipByLink(source_type, id) {
    return Repository.get('/documents/zip/' + source_type + '/' + id, {
      responseType: 'arraybuffer',
    })
  },
  get(id) {
    return Repository.get('/documents/' + id)
  },
  getRegistry(day_id, bid_creator_inn, registry = 'registry') {
    return Repository.post(
      `/excel-builder/template/${registry}`,
      {
        day_id,
        bid_creator_inn,
      },
      { responseType: 'arraybuffer' },
    )
  },
  getReportForwarder(dateForm, dateTo) {
    return Repository.post(
      '/excel-builder/template/hartia',
      {
        date_from: dateForm,
        date_to: dateTo,
      },
      { responseType: 'arraybuffer' },
    )
  },
  createActDocument(document) {
    return Repository.post(action, document)
  },
  updateActDocument({ id, ...document }) {
    return Repository.put(`${action}/${id}`, document)
  },
  signDocument(data) {
    return Repository.post(action + '/sign', data)
  },
  unloadingBank(data) {
    return Repository.post(`txt-builder/template/second-payments`, data, {
      responseType: 'arraybuffer',
    })
  },
  getLastEdited() {
    return Repository.get(`${action}/last-edited`)
  },
  getRiester() {
    return `${baseURL}documents/zip-registry?token=${hardwareToken}`
  },
  downloadResponses(params) {
    const token = localStorage.getItem('auth-token')

    return Repository.get(
      `word-builder/logistic-request?response_ids=${params}&bearer-token=${token}`,
    )
  },
  getStatisticsForBids(data) {
    let params = getParamsUrl(data)

    return Repository.get(`word-builder/active-bids` + params)
  },
}
